import { motion, AnimatePresence } from "framer-motion";
import { CheckIcon } from "@heroicons/react/outline";

import { cn } from "@/lib/utils";

interface GroupTitleProps {
  group: string;
  groupIndex: number;
  isGroupCompleted: boolean;
  isActiveGroup: boolean;
}

export const GroupTitle = ({
  group,
  groupIndex,
  isGroupCompleted,
  isActiveGroup,
}: GroupTitleProps) => (
  <motion.div
    className="mb-2 flex items-center gap-2 text-sm font-medium text-gray-900"
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.2, delay: groupIndex * 0.1 }}
  >
    <motion.div
      className={cn(
        "flex h-5 w-5 items-center justify-center rounded-full text-xs font-semibold transition-colors duration-200",
        isGroupCompleted
          ? "border border-green-300 bg-green-50 text-green-500"
          : "border border-gray-300 bg-gray-50 text-gray-500",
        isActiveGroup && "!border-blue-300 !bg-blue-50 !text-blue-500",
      )}
    >
      <AnimatePresence mode="wait">
        {isGroupCompleted ? (
          <motion.div
            key="check"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.15, ease: "easeOut" }}
          >
            <CheckIcon className="h-3 w-3 text-green-500" />
          </motion.div>
        ) : (
          <motion.span
            key="number"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15, ease: "easeOut" }}
          >
            {groupIndex + 1}
          </motion.span>
        )}
      </AnimatePresence>
    </motion.div>
    <motion.span className="text-sm font-medium text-gray-700" transition={{ duration: 0.2 }}>
      {group}
    </motion.span>
  </motion.div>
);
